import { render, staticRenderFns } from "./ValesTransportes.vue?vue&type=template&id=607ee036&"
import script from "./ValesTransportes.vue?vue&type=script&lang=js&"
export * from "./ValesTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports